import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { ISector } from '../../interfaces/ISector';

const apiUrl = Globals.apiPath + '/sectors';

export interface ICreateSectorDto {
  restaurantId: number;
  branchId: number;
  name: string;
  color?: string;
  gridCols?: number;
  gridRows?: number;
}

export interface IUpdateSectorDto {
  name?: string;
  color?: string;
  gridCols?: number;
  gridRows?: number;
}

export default class SectorsService {
  static async getAll(
    restaurantId: number,
    branchId: number
  ): Promise<ISector[]> {
    const res = await axios.get<ISector[]>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}`
    );
    return res.data;
  }

  static async create(data: ICreateSectorDto): Promise<ISector> {
    const res = await axios.post<ISector>(apiUrl, data);
    return res.data;
  }

  static async update(id: number, data: IUpdateSectorDto): Promise<ISector> {
    const res = await axios.put<ISector>(`${apiUrl}/${id}`, data);
    return res.data;
  }

  static async reorder(
    restaurantId: number,
    branchId: number,
    ids: number[]
  ): Promise<ISector[]> {
    const res = await axios.post<ISector[]>(`${apiUrl}/reorder`, {
      restaurantId,
      branchId,
      ids,
    });
    return res.data;
  }

  static async delete(id: number): Promise<ISector> {
    const res = await axios.delete<ISector>(`${apiUrl}/${id}`);
    return res.data;
  }
}
